import Tagify from '@yaireo/tagify';


function formsInit (){

    document.addEventListener('input', (e)=> {
        if (e.target.closest('.form_relative') && !e.target.closest('.form_relative').classList.contains('is-active') && (e.target.value.length > 0)){
            e.target.closest('.form_relative').classList.add('is-active');
        } else if (e.target.closest('.form_relative') && (e.target.value.length === 0)){
            e.target.closest('.form_relative').classList.remove('is-active');
        }
    })

    // const forms = document.querySelectorAll('.form');
    
    // if (forms){
    //     for (let i = 0; i < forms.length; i++) {
    //         const groups = forms[i].querySelectorAll('.form_relative');
    //         for (let j = 0; j < groups.length; j++) {
    //             const control = groups[j].querySelector('input,textarea,select');
                
    //             // if (control.value.length > 0) {
    //             //   groups[j].classList.add('is-active');
    //             // }
    //             // groups[j].classList.remove('is-active');
  
    //             if (control){
    //                 control.addEventListener('input', () => {
    //                     if (control.value.length > 0) {
    //                         groups[j].classList.add('is-active');
    //                     } else {
    //                         groups[j].classList.remove('is-active');
    //                     }
    //                 });
    //             }
  
    //         }
    //     }
    // }
};

module.exports = { formsInit };



var tagifys = document.querySelectorAll('.tagify');

if (tagifys) {
    tagifys.forEach(tagify => {
    const whitelist = tagify.dataset.whitelist
    new Tagify(tagify, {
        // A list of possible tags. This setting is optional if you want to allow
        // any possible tag to be added without suggesting any to the user.
        whitelist: whitelist,
        maxTags: 10,
        dropdown: {
            maxItems: 20,           // <- mixumum allowed rendered suggestions
            classname: 'tags-look', // <- custom classname for this dropdown, so it could be targeted
            enabled: 0,             // <- show suggestions on focus
            closeOnSelect: false    // <- do not hide the suggestions dropdown once an item has been selected
        }
      })
    });
}




